import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeLeadCaptureModal from "./sections/WelcomeLeadCaptureModal";
import PropertySearch from "./sections/PropertySearch";
import ChooseYourPath from "./sections/ChooseYourPath";
import WhyChooseOwnerFinancing from "./sections/WhyChooseOwnerFinancing";
import FeaturedPrivateListings from "./sections/FeaturedPrivateListings";
import MarketSnapshot from "./sections/MarketSnapshot";
import ReadyToMove from "./sections/ReadyToMove";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WelcomeLeadCaptureModal />
      <PropertySearch />
      <ChooseYourPath />
      <WhyChooseOwnerFinancing />
      <FeaturedPrivateListings />
      <MarketSnapshot />
      <ReadyToMove />
      <Footer />
    </div>;
}